// This file is used to define reducers for the slice, and has no exports

import { setTestProfile } from "./actions";
import slice from "./slice";

slice.reducer(setTestProfile, (state, { payload }) => {
  state.meta[payload.apiId].testProfile = payload.profile;
});
